export enum CourseLevel {
  Undefined = 0,
  Beginner = 1,
  Intermediate = 2,
  Advanced = 3
}

export const courseLevelNames: Record<CourseLevel, string> = {
  [CourseLevel.Undefined]: '',
  [CourseLevel.Beginner]: 'Начинающий',
  [CourseLevel.Intermediate]: 'Средний',
  [CourseLevel.Advanced]: 'Продвинутый',
};
